import React from 'react';
import { createPortal } from 'react-dom';
import './GameAnnouncement.css';

const announcement = '/assets/features/province-war/announcement-99d9ecd853fc.png';
const storageKey = 'pknin:announcement:20261103:hidden-day';
export const announcementDay = () => new Date(Date.now() + 7 * 60 * 60 * 1000).toISOString().slice(0, 10);

export function GameAnnouncement() {
  const [open, setOpen] = React.useState(() => {
    try { return localStorage.getItem(storageKey) !== announcementDay(); }
    catch { return true; }
  });
  const [hideToday, setHideToday] = React.useState(false);
  const closeButton = React.useRef<HTMLButtonElement>(null);
  const checkbox = React.useRef<HTMLInputElement>(null);
  const close = React.useCallback(() => {
    if (hideToday) {
      try { localStorage.setItem(storageKey, announcementDay()); } catch { /* Storage may be disabled. */ }
    }
    setOpen(false);
  }, [hideToday]);

  React.useEffect(() => {
    if (!open) return;
    const previous = document.activeElement as HTMLElement | null;
    closeButton.current?.focus();
    const onKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') { event.preventDefault(); event.stopPropagation(); close(); }
      if (event.key === 'Tab') {
        event.preventDefault();
        if (document.activeElement === closeButton.current) checkbox.current?.focus();
        else closeButton.current?.focus();
      }
    };
    document.addEventListener('keydown', onKey, true);
    return () => {
      document.removeEventListener('keydown', onKey, true);
      if (previous?.isConnected) previous.focus();
    };
  }, [open, close]);

  if (!open) return null;
  return createPortal(
    <div className="game-announcement-backdrop" onPointerDown={(event) => event.stopPropagation()}>
      <section className="game-announcement" role="dialog" aria-modal="true" aria-labelledby="game-announcement-title">
        <header className="game-announcement-titlebar">
          <h2 id="game-announcement-title">ประกาศ</h2>
          <button ref={closeButton} type="button" aria-label="ปิดประกาศ" onClick={close}>×</button>
        </header>
        <div className="game-announcement-content">
          <img src={announcement} alt="ประกาศกิจกรรมศึกชิงสุดยอดแห่งแคว้น" draggable={false} />
          <label className="game-announcement-option">
            <input ref={checkbox} type="checkbox" checked={hideToday} onChange={(event) => setHideToday(event.target.checked)} />
            วันนี้ไม่ต้องแสดงอีก
          </label>
        </div>
      </section>
    </div>, document.body
  );
}
